import { TileLayer } from "react-leaflet";
import useTranslation from '../../../Language/useTranslation';

function WaldzustandsTileLayer({ activeLayer, version }) {
    const t = useTranslation();

    const layer = t.layersWaldzustand.find(layer => layer.label === activeLayer && layer.period === version);

    return layer ? (
        <TileLayer
            key={`${layer.label}-${version}`}
            url={layer.url}
            zIndex={9}
        />
    ) : null;
}

export default WaldzustandsTileLayer;